export const FETCH_ACCOUNTS = 'FETCH_ACCOUNTS';
export const FETCH_ACCOUNTS_PENDING = 'FETCH_ACCOUNTS_PENDING';
export const FETCH_ACCOUNTS_REJECTED = 'FETCH_ACCOUNTS_REJECTED';
export const FETCH_ACCOUNTS_FULFILLED = 'FETCH_ACCOUNTS_FULFILLED';
export const initialState = {
  isLoading: true,
  accounts: []
};
export const reducer = (state, action) => {
  switch (action.type) {
    case FETCH_ACCOUNTS_FULFILLED:
      return Object.assign({}, state, {
        accounts: action.payload,
        isLoading: false
      });
    case FETCH_ACCOUNTS_REJECTED:
      return Object.assign({}, state, {
        isLoading: false,
        accounts: []
      });
    case FETCH_ACCOUNTS_PENDING:
      return Object.assign({}, state, {
        isLoading: true
      });
    default:
      return state;
  }
};